import type { FilmCategory, NewsCategory } from "@/types";

export const filmCategoryMeta: Record<
  FilmCategory,
  { label: string; en: string; intro: string }
> = {
  movie: {
    label: "电影",
    en: "Movie",
    intro:
      "汇聚剧情、动作、科幻、爱情等多元题材，从院线大片到独立佳作，带你走进银幕世界的光影与情感。",
  },
  tv: {
    label: "电视剧",
    en: "TV Series",
    intro:
      "历史、都市、家庭、悬疑……数不清的剧集陪伴无数个夜晚。这里有最值得追的故事，也有最打动人的表演。",
  },
  variety: {
    label: "综艺",
    en: "Variety",
    intro:
      "竞技、音乐、旅行、真人秀，类型丰富、轻松有趣。在工作与生活之间，用一档综艺找回久违的快乐。",
  },
};

export const newsCategoryMeta: Record<
  NewsCategory,
  { label: string; intro: string }
> = {
  industry: {
    label: "行业动态",
    intro: "聚焦影视产业趋势、市场观察与研究数据，把握内容行业的最新脉搏。",
  },
  company: {
    label: "公司新闻",
    intro: "星光传媒的最新动态、业务进展与品牌活动，在这里第一时间了解我们。",
  },
  release: {
    label: "作品发布",
    intro: "新片定档、剧集开播、综艺上线，第一时间获取星光传媒作品发布信息。",
  },
  interview: {
    label: "人物访谈",
    intro: "走进创作者的世界，聆听导演、编剧与制片人关于作品与行业的思考。",
  },
};

export const genreOptions = [
  "剧情",
  "悬疑",
  "科幻",
  "动作",
  "爱情",
  "喜剧",
  "历史",
  "都市",
  "家庭",
  "竞技",
  "音乐",
  "旅行",
  "美食",
];

export const regionOptions = ["中国大陆", "中国香港", "美国", "日本", "韩国"];

export const yearOptions = ["2025", "2024", "2023"];